<template>
  <v-container fluid class="bgcCadastroInicial">
    <v-row
      v-if="step === 0"
      class="bgcObrigado"
      style="height: calc(100vh + 64px); padding: 0px 64px"
    >
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-center align-center flex-column"
      >
        <div
          style="background-color: #ffffff38; border-radius: 8px; padding: 20px"
        >
          <h1
            class="titleScope fontSizeMobile mx-auto"
            style="color: white; font-size: 18px"
          >
            Informe seu e-mail para iniciar o cadastro
          </h1>
          <div class="d-flex align-center flex-column" style="margin-top: 20px">
            <v-text-field
              color="#ff770f"
              placeholder="E-mail"
              filled
              v-model="u.email"
              dark
              prepend-inner-icon="mdi-email"
            >
            </v-text-field>
            <v-btn @click="verificaEmail" dark class="mt-5" color="#00294B"
              >Iniciar <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="6"> </v-col>
    </v-row>

    <v-row v-if="step === 1" class="mt-5">
      <v-col cols="12" md="10"  offset-md="1">
        <h2
          class="rounded pa-5 d-flex align-center"
          style="background-color: #ffffff99; color: #ff770f"
        >
          <v-icon x-large color="#FF770F">mdi-book-account-outline</v-icon>
          Cadastro Ribus
        </h2>
      </v-col>
      <v-col cols="12" md="10" offset-md="1">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step color="#FF770F" :complete="e1 > 1" step="1">
              Vamos começar, conte para nós quem é você.
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="#FF770F" :complete="e1 > 2" step="2">
              Qual é o seu endereço
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="#FF770F" :complete="e1 > 3" step="3">
              Dados da Parceria
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12"
                color="white"
               elevation="0"
              >
                <v-row style="">
                  <v-col cols="12" md="12">
                    <h2 style="color: #ff770f">Identificação</h2>
                  </v-col>
                  <v-col cols="12" md="12" align="center">
                    <v-btn-toggle
                      mandatory
                      v-model="u.tipoPessoa"
                      style="color: #ff770f"
                    >
                      <v-btn>Pessoa Física</v-btn>
                      <v-btn>Pessoa Jurídica</v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-account"
                      color="#ff770f"
                      :label="u.tipoPessoa === 0 ? `Nome` : `Nome Fantasia`"
                      outlined
                      v-model="u.name"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col v-if="u.tipoPessoa === 0" cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-cake-variant-outline"
                      color="#ff770f"
                      label="Data de nascimento"
                      placeholder="Data de nascimento"
                      v-model="u.birthdate"
                      outlined
                      v-mask="`##/##/####`"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col v-if="u.tipoPessoa === 1" cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-factory"
                      color="#ff770f"
                      label="Razão Social"
                      placeholder="Razão Social"
                      v-model="u.razaoSocial"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-card-bulleted-outline"
                      color="#ff770f"
                      :label="u.tipoPessoa === 0 ? `CPF` : `CNPJ`"
                      v-model="u.document"
                      v-mask="
                        u.tipoPessoa === 0
                          ? `###.###.###-##`
                          : `##.###.###/####-##`
                      "
                      @blur="verificaDocumento"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      prepend-inner-icon="mdi-phone"
                      color="#ff770f"
                      label="Celular"
                      placeholder="Celular"
                      outlined
                      v-model="u.phone"
                      v-mask="`(##) # ####-####`"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      color="#ff770f"
                      v-model="u.infos.isWhatsapp"
                      :label="``"
                    >
                      <template v-slot:label>
                        <div>É WHATSAPP?</div>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-email"
                      color="#ff770f"
                      @blur="verificaEmail"
                      label="E-mail"
                      placeholder="E-mail"
                      outlined
                      v-model="u.email"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-lock"
                      color="#ff770f"
                      label="Senha"
                      placeholder="Senha"
                      outlined
                      v-model="u.passwd"
                      type="password"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
              <v-row
                style="justify-content: end; height: 64px; padding-right: 10px"
              >
                <!-- <v-btn text to="/"> Voltar </v-btn> -->
                <v-btn
                  class="mr-1"
                  style="background-color: #ff770f; color: #fff"
                  @click="validaCNPJ"
                >
                  Continuar
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mb-12"
                color="white lighten-1"
                style="box-shadow: none !important"
              >
                <v-row>
                  <v-col cols="12" md="12">
                    <h2 style="color: #ff770f">Endereço</h2>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-map-marker"
                      label="CEP"
                      placeholder="CEP"
                      v-model="u.address.zip_code"
                      @keyup="buscaCEP"
                      @blur="buscaCEP"
                      :append-icon="loadingCep ? 'mdi-loading' : ''"
                      outlined
                      v-mask="`########`"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      prepend-inner-icon="mdi-home"
                      color="#ff770f"
                      label="Logradouro"
                      placeholder="Logradouro"
                      v-model="u.address.street"
                      outlined
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-numeric"
                      label="Número"
                      placeholder="Número"
                      v-model="u.address.number"
                      outlined
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-city"
                      label="Complemento"
                      placeholder="Complemento"
                      v-model="u.address.complement"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-home-group"
                      label="Bairro"
                      placeholder="Bairro"
                      v-model="u.address.district"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-home-city"
                      label="Cidade"
                      placeholder="Cidade"
                      v-model="u.address.city"
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      color="#ff770f"
                      prepend-inner-icon="mdi-sign-real-estate"
                      label="Estado"
                      placeholder="Estado"
                      v-model="u.address.state"
                      outlined
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="12"> </v-col>
                </v-row>
              </v-card>
              <v-row style="justify-content: end; height: 64px" align="center">
                <v-btn text @click="e1 = 1"> Voltar </v-btn>
                <v-btn
                  style="background-color: #ff770f; color: #fff"
                  class="mr-3"
                  @click="validaEndereco"
                >
                  Continuar
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mb-12"
                color=""
                style="box-shadow: none !important"
              >
                <v-row
                  v-if="step === 1"
                  align="center"
                  justify="center"
                  align-content="center"
                  class="bgcHomeRibus paddingMobile"
                  style="padding: 20px 64px 0px"
                >
                  <v-col
                    cols="12"
                    md="10"
                    class="d-flex justify-center algin-center flex-column"
                  >
                    
                  </v-col>
                </v-row>
              </v-card>

              
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    color="#ff770f"
                    v-model="u.infos.accepted_terms"
                    :label="``"
                  >
                    <template v-slot:label>
                      <div class="px-3">
                        ESTOU CIENTE E ACEITO TODOS OS TERMOS E AS CONDIÇÕES
                        DISPOSTAS NOS <a                 @click.stop
 href="/docs/Termos-e-Condicoes-de-Uso.pdf" target="_blank">TERMOS DE USO</a> E NA
                        <a                 @click.stop
 href="/docs/Politica-de-Privacidade.pdf" target="_blank">POLÍTICA DE PRIVACIDADE</a> DA RIBUS, E
                        CONCORDO COM A PUBLICAÇÃO DOS MEUS DADOS NO MARKETPLACE
                        RIBUS, TAIS COMO, RAZÃO SOCIAL E/OU NOME FANTASIA,
                        E-MAIL, TELEFONE, SITE, DESCRIÇÃO DO NEGÓCIO E
                        LOGOMARCA, DE ACORDO COM O DISPOSTO NO MEU CADASTRO
                        REALIZADO NA PLATAFORMA RIBUS.
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row
                align="center"
              >
                <v-col cols="12" md="6">
                  <v-btn text @click="e1 = 2"> Voltar </v-btn>

                </v-col>
                <v-col style="display:flex; flex-direction:column; justify-content: center;" cols="12" md="6">
                  <v-btn
                   
                    :loading="loading"
                    :disabled="loading"
                    style="background-color: #f0f0f0; color: #ff770f"
                    @click="(files !== undefined && files !== null) ? enviarArquivo() : fazerCadastro()"
                  >
                    <span >Finalizar o cadastro</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
          <div class="pa-5">
            <p
              style="background-color: #ff770f20"
              :class="intBreakPoint > 2 ? ' flex-row' : 'flex-column'"
              class="pa-5 d-flex align-center"
            >
              <v-icon
                class="mr-2 pa-2"
                style="background-color: #ff770f; border-radius: 300px"
                color="white"
                >mdi-help</v-icon
              ><b class="mr-1">Dúvidas:</b> Entre em contato pelo email
              <a
                class="mx-1"
                target="_blank"
                href="mailto:contato@ribus.com.br"
              >
                contato@ribus.com.br
              </a>
              ou pelo site
              <a class="mx-1" target="_blank" href="https://ribus.com.br"
                >Ribus.com.br</a
              >
            </p>
          </div>
        </v-stepper>
      </v-col>
    </v-row>    
  </v-container>
</template>

<style scoped>
a {
  color: #ff770f !important;
}

@media (min-device-width: 820px) and (max-device-width: 1200px) {
  .paddingTablet {
    padding: 20px !important;
  }
}

@media (min-device-width: 300px) and (max-device-width: 731px) {
  .alturaLinhaMobile {
    height: 104px !important;
  }


  .paddingMobile {
    padding: 60px 10px 0px !important;
  }

  .offset-3 {
    margin-left: 0% !important;
  }

  .fontSizeMobile {
    font-size: 47px !important;
  }
}

.v-application .primary {
  background-color: #ff770f !important;
  border-color: #fb8c00 !important;
}
.bgcCadastroInicial {
  background-image: url("../assets/bannerCadastro.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.bgcObrigado {
  background-image: url("../assets/capacadastro.jpg");
  background-repeat: no-repeat;
  height: 100vh;
  background-size: cover;
  background-position: center;
}

.btnLimpar {
  background-color: transparent !important;
  box-shadow: none !important;
  margin-bottom: 0px;
  font-family: montserrat;
  font-size: 14px;
  color: #ff770f !important;
  font-weight: 500;
  text-transform: capitalize;
}

.StyleButton {
  background-color: #ff770fe0 !important;
  color: #fff !important;
  font-family: "Poppins";
  border-radius: 50px;
}

.titleCarrocel {
  font-size: 28px;
  font-family: "Poppins";
  font-weight: 500;
  color: #fff;
  text-align: left;
}

.titleScope {
  font-size: 32px;
  font-family: "Poppins";
  line-height: 1;
  font-weight: 500;
  text-align: left;
}

.textScopeDepoiments {
  margin-bottom: 0px;
  font-size: 15px;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
}

.textScope {
  margin-bottom: 0px;
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 400;
  text-align: left;
}
</style>

<script>
export default {
  name: "cadastroUsuario",
  metaInfo: {
    title: "Cadastro Parceiros - MarketPlace Ribus",
  },
  data: () => ({
    loading: false,
    files: undefined,
    e1: 1,
    step: 1,
    parceiro: false,
    loadingCep: false,
    u: {
      name: ``,
      passwd: ``,
      email: ``,
      phone: ``,
      birthdate: ``,
      tipoPessoa: 0,
      interest: ``,
      categories: [],
      document: ``,
      is_partner: 0,
      parent_code: ``,
      description: ``,
      address: { 
        zip_code: '',
        street: '',
        number: '',
        complement: '',
        city: '',
        state: '',
        country_id: 1
      },
      infos: {
        isWhatsapp: false,
        social: {site: "", fb:"", ig:"", linkedin:""},
        accepted_terms: false,
        interest:"",
        accepted_tokens_percentual:0,
        prof_document_emissor:"",
        prof_document: ""
      },
      u: {}
    }
  }),

  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.idIndicacao) {
      this.u.parent_code = this.$route.params.idIndicacao;
    }
  },
  
  computed: { 
     areaOcupacao() {
      return this.$store.state.categorias;
    },
    intBreakPoint() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 3;
        case "xl":
          return 4;
        default:
          return 0;
      }
    },
  },
  methods: {
    reloadCategorias() { 
      this.$store.dispatch("getCategories")
    },
    checkPercentual() { 
      if (this.u.infos.accepted_tokens_percentual > 100) {
        this.u.infos.accepted_tokens_percentual = 100;
      }
      if (this.u.infos.accepted_tokens_percentual < 5) {
        this.u.infos.accepted_tokens_percentual = 5
      }
      return;
    },
    enviarArquivo() {
      this.loading = true
      const formData = new FormData();
      formData.append("file", this.files);
      this.$http
        .post("/files/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status  === "OK") {
            this.u.files =  []
            this.u.files.push({name: response.data.result.fileName ,value: response.data.result.identifier})
            this.fazerCadastro()
          }else {
               let text = response.data.result.message
              this.$root.$emit("show-snack", {type:`error`, text:text});
                    this.loading = false

              }
            }).catch((err) => {
                    this.loading = false

              // console.log(err.response)
              let text = err.response.data.result.message
              this.$root.$emit("show-snack", {type:`error`, text:text});

            });
    },
    buscaCEP() {
      //Verifica se campo cep possui valor informado.
      if (this.u.address.zip_code != undefined) {
        var cep = this.u.address.zip_code.replace(/\D/g, "");

        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          fetch("https://viacep.com.br/ws/" + cep + "/json")
            .then((response) => response.json())
            .then((data) => {
              this.u.address.street = data.logradouro;
              this.u.address.district = data.bairro;
              this.u.address.city = data.localidade;
              this.u.address.state = data.uf;
              this.u.address.complement = data.complemento;
              // this.$forceUpdate();  // Notice we have to use a $ here
              this.loadingCep = false;
            });
        }
        return this.u.address.zip_code;
      }
      return this.u.address.zip_code;
    },
    toTop(int) {
      this.$vuetify.goTo(int);
    },
    validaCNPJ() {
      if (this.u.tipoPessoa === 0 && this.cpfValidation(this.u.document)) {
        if (
          this.u.nome !== "" &&
          this.u.birthdate !== "" &&
          this.u.phone !== "" &&
          this.u.email !== "" &&
          this.u.passwd !== ""
        ) {
          this.e1 = 2;
          window.scrollTo(0, 150);
          return;
        }
        else {
          this.$root.$emit("show-snack", {type:`error`, text:`Por favor preencha seus dados pessoais`});
          return;
        }
      }
      if (this.u.tipoPessoa === 1 && this.cnpjValidation(this.u.document)) {
        if (
          this.u.razaoSocial != "" &&
          this.u.phone != "" &&
          this.u.email != "" &&
          this.u.passwd
        ) {
          window.scrollTo(0, 150);
          this.e1 = 2;
          return;
        } else {
          this.$root.$emit("show-snack", {type:`error`, text:"Por favor preencha os dados da sua empresa."});
          return;
        }
      }
      this.$root.$emit("show-snack", {type:`error`, text:  `Por favor insira um ${this.u.tipoPessoa === 0 ? `CPF` : `CNPJ`} válido`});

    },
    validaEndereco() {
      if (
        this.u.address.zip_code != "" &&
        this.u.address.street != "" &&
        this.u.address.number != "" &&
        this.u.address.city != "" &&
        this.u.address.state != "" &&
        this.u.address.district != ""
      ) {
        window.scrollTo(0, 150);

        this.e1 = 3;
        return;
      }
      this.$root.$emit("show-snack", {type:`error`, text:"Por favor preencha o seu endereço."});
    },
    fazerCadastro() {
      
      if (this.u.infos.accepted_terms === false) {
        this.$root.$emit("show-snack", {type:`warning`, text:"Por favor aceite os termos de uso e privacidade."});
        this.loading = false

        return;
      }
      if ((this.u.is_partner === 1) && (this.u.categories.length === 0)) { 
        this.$root.$emit("show-snack", {type:`warning`, text:"Por favor escolha ao menos uma área de atuação."});
        this.loading = false
        return;
      }
      if ((this.u.is_partner === 1) && (this.u.description.length < 20)) { 
        this.$root.$emit("show-snack", {type:`warning`, text:"Por favor uma descrição com ao menos 20 caracteres."});
        this.loading = false
        return;
      }

      this.loading = true
      const headers = {
        'Content-Type': 'application/json',
      }
      this.$http.post("/users/add", this.u,{ headers: headers})
        .then((response) => {
          if (response.data.status == "OK") {
            this.$router.replace("obrigado")
            window.scrollTo(0, 0);
          }
          else { 
            this.loading = false
            let dt = JSON.stringify(response.data) 
            this.sendError({data: dt})
            this.$root.$emit("show-snack", { type:`error`, text: response.data.status });
          }
        })
        .catch((err) => {
          let text = ""
          err.response.data.result.fields.forEach((el) => { 
            if (el.message._required !== undefined) { 
              text += el.message._required +"\r\n"
            }
            else { 
              text += el.message +"\r\n"
            }
          })
          this.$root.$emit("show-snack", {type:`error`, text:text});
          this.sendError({text})
          this.loading = false
        });
    },
    sendError(err) { 
      fetch("https://gestao.abare.cloud/items/err_mktplace", {
          method: "POST",
          headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          },
          body: JSON.stringify({ content: err}),
      })
      .then((response) => response.text())
      .then(() => {}).catch(() => { });
    },
    verificaEmail() {
      this.$http({
        method: `GET`,
        url: "users/verify_email?email=" + encodeURIComponent(this.u.email),
      })
        .then((resp) => {
          if (resp.data.result.message == "true") {
            this.$root.$emit("show-snack",{ type:`warning`, text: "Identificamos que você ja está cadastrado, por favor realize o login."});
            this.$root.$emit("show-login");
          }
        })
        .catch(() => {
          this.$root.$emit("show-snack", {type:`error`, text: "Erro de conexão ao verificar o email, por favor tente novamente."});
        });
    },
    verificaDocumento() {
      this.$http({
        method: `GET`,
        url:
          "users/verify_document?document=" + encodeURIComponent(this.u.document),
      })
        .then((resp) => {
          if (resp.data.result.message === "true") {
            this.$root.$emit("show-snack", {type:`warning`, text: "Identificamos que você ja está cadastrado, por favor realize o login."});
            this.$root.$emit("show-login");
          }
        })
        .catch(() => {
          this.$root.$emit("show-snack",{type:`error`, text: "Erro de conexão ao verificar o documento, por favor tente novamente."});
        });
    },
    cpfValidation(value) {
      if (!value) return false;

      // Aceita receber o valor como string, número ou array com todos os dígitos
      const validTypes =
        typeof value === "string" ||
        Number.isInteger(value) ||
        Array.isArray(value);

      // Elimina valores com formato inválido
      if (!validTypes) return false;

      // Guarda todos os dígitos em um array
      const numbers = value.toString().match(/\d/g).map(Number);

      // Valida quantidade de dígitos
      if (numbers.length !== 11) return false;

      // Elimina valores inválidos com todos os dígitos repetidos
      const items = [...new Set(numbers)];
      if (items.length === 1) return false;

      // Separa número base do dígito verificador
      const base = numbers.slice(0, 9);
      const digits = numbers.slice(9);

      // Cálculo base
      const calc = (n, i, x) => n * (x - i);

      // Utilitário de soma
      const sum = (r, n) => r + n;

      // Cálculo de dígito verificador
      const digit = (n) => {
        const rest = n % numbers.length;
        return rest < 2 ? 0 : numbers.length - rest;
      };

      // Cálculo sobre o número base
      const calc0 = base
        .map((n, i) => calc(n, i, numbers.length - 1))
        .reduce(sum, 0);
      // 1o. dígito verificador
      const digit0 = digit(calc0);

      // Valida 1o. digito verificador
      if (digit0 !== digits[0]) return false;

      // Cálculo sobre o número base + 1o. dígito verificador
      const calc1 = base
        .concat(digit0)
        .map((n, i) => calc(n, i, numbers.length))
        .reduce(sum, 0);
      // 2o. dígito verificador
      const digit1 = digit(calc1);

      // Valida 2o. dígito verificador
      return digit1 === digits[1];
    },
    cnpjValidation(value) {
      if (!value) return false;

      // Aceita receber o valor como string, número ou array com todos os dígitos
      const isString = typeof value === "string";
      const validTypes =
        isString || Number.isInteger(value) || Array.isArray(value);

      // Elimina valor em formato inválido
      if (!validTypes) return false;

      // Filtro inicial para entradas do tipo string
      if (isString) {
        // Limita ao máximo de 18 caracteres, para CNPJ formatado
        if (value.length > 18) return false;

        // Teste Regex para veificar se é uma string apenas dígitos válida
        const digitsOnly = /^\d{14}$/.test(value);
        // Teste Regex para verificar se é uma string formatada válida
        const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value);

        // Se o formato é válido, usa um truque para seguir o fluxo da validação
        if (digitsOnly || validFormat) true;
        // Se não, retorna inválido
        else return false;
      }

      // Guarda um array com todos os dígitos do valor
      const match = value.toString().match(/\d/g);
      const numbers = Array.isArray(match) ? match.map(Number) : [];

      // Valida a quantidade de dígitos
      if (numbers.length !== 14) return false;

      // Elimina inválidos com todos os dígitos iguais
      const items = [...new Set(numbers)];
      if (items.length === 1) return false;

      // Cálculo validador
      const calc = (x) => {
        const slice = numbers.slice(0, x);
        let factor = x - 7;
        let sum = 0;

        for (let i = x; i >= 1; i--) {
          const n = slice[x - i];
          sum += n * factor--;
          if (factor < 2) factor = 9;
        }

        const result = 11 - (sum % 11);

        return result > 9 ? 0 : result;
      };

      // Separa os 2 últimos dígitos de verificadores
      const digits = numbers.slice(12);

      // Valida 1o. dígito verificador
      const digit0 = calc(12);
      if (digit0 !== digits[0]) return false;

      // Valida 2o. dígito verificador
      const digit1 = calc(13);
      return digit1 === digits[1];
    },
  },
};
</script>
